import { Button } from 'components/button';
import { CountryAndLanguage } from 'components/countryAndLanguage';
import { CollectionProvider, useCollectionContext } from 'components/settings/collectionContext';
import { useAccountRecord, useUserProfile } from 'components/settings/userProfileContext';
import { addDoc, collection, doc, updateDoc } from 'firebase/firestore';
import { db } from 'firebaseStore';
import {
    Account,
    accountConverter,
    ACCOUNT_COLLECTION_NAME,
    countryConverter,
    COUNTRY_COLLECTION_NAME,
    languageConverter,
    LANGUAGE_COLLECTION_NAME,
} from 'models';
import { useState } from 'react';
import Modal from 'react-modal';

import './accountPage.css';

Modal.setAppElement('#modal');

export const AccountPage = () => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minHeight: '100vh',
                width: 'calc(100vw - 256px)',
                margin: '76px 128px 0 128px',
            }}
        >
            <CollectionProvider
                collectionName={ACCOUNT_COLLECTION_NAME}
                converter={accountConverter}
            >
                <CollectionProvider
                    collectionName={LANGUAGE_COLLECTION_NAME}
                    converter={languageConverter}
                >
                    <CollectionProvider
                        collectionName={COUNTRY_COLLECTION_NAME}
                        converter={countryConverter}
                    >
                        <AccountPageWrapper />
                    </CollectionProvider>
                </CollectionProvider>
            </CollectionProvider>
        </div>
    );
};

export const AccountPageWrapper = () => {
    const account = useAccountRecord();
    console.log('AccountPageWrapper account', account);
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minHeight: '100vh',
                width: 'calc(100vw - 256px)',
                margin: '76px 128px 0 128px',
            }}
        >
            {account ? <AccountPageContent account={account} /> : 'Loading...'}
        </div>
    );
};

const AccountPageContent = ({ account }: { account: Account }) => {
    const [me] = useUserProfile();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [nextAccount, setNextAccount] = useState(account);
    const market = nextAccount.markets[0] || { countryIndexId: '', languageIndexId: '' };
    const [countryIndexId, setCountryIndexId] = useState<string>(market.countryIndexId);
    const [languageIndexId, setLanguageIndexId] = useState<string>(market.languageIndexId);
    const [, , , languageMap] = useCollectionContext(LANGUAGE_COLLECTION_NAME);
    const [, , , countryMap] = useCollectionContext(COUNTRY_COLLECTION_NAME);
    const collectionRef = collection(db, ACCOUNT_COLLECTION_NAME).withConverter(accountConverter);
    const onSave = async () => {
        console.log('onSave nextAccount', nextAccount.toFirestore());
        if (nextAccount.id) {
            return updateDoc(
                doc(db, ACCOUNT_COLLECTION_NAME, nextAccount.id),
                nextAccount.toFirestore()
            ).then(
                () => null,
                (error) => {
                    console.error('Update updateDoc error', error);
                }
            );
        }
        return addDoc(collectionRef, nextAccount).then(
            async (newDocRef) => {
                return updateDoc(newDocRef, nextAccount.toFirestore()).then(
                    () => null,
                    (error) => {
                        console.error('Save updateDoc error', error);
                    }
                );
            },
            (error) => {
                console.error('addDoc error', error);
            }
        );
    };
    return (
        <div style={{ width: '100%' }}>
            <Modal
                isOpen={modalIsOpen}
                style={{
                    content: {
                        width: '518px',
                        height: '',
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                        fontFamily: 'Abel',
                        padding: '0',
                        backgroundColor: '#fbfbfb',
                    },
                }}
                onRequestClose={() => setModalIsOpen(false)}
            >
                <CountryAndLanguage
                    countryIndexId={countryIndexId}
                    setCountryIndexId={setCountryIndexId}
                    languageIndexId={languageIndexId}
                    setLanguageIndexId={setLanguageIndexId}
                    onSave={() => {
                        if (!countryIndexId || !languageIndexId) {
                            return;
                        }
                        setNextAccount(
                            new Account({
                                ...account,
                                markets: [{ countryIndexId, languageIndexId }],
                            })
                        );
                        setModalIsOpen(false);
                        setCountryIndexId('');
                        setLanguageIndexId('');
                    }}
                    onCancel={() => setModalIsOpen(false)}
                />
            </Modal>
            {me?.admin() && (
                <Button
                    theme="soft"
                    style={{ width: 'inherit' }}
                    onClick={() => setModalIsOpen(true)}
                >
                    Select main country and a language
                </Button>
            )}
            <div
                className="listRecords"
                style={{
                    margin: '10px 0 20px 0',
                }}
            >
                {nextAccount.markets.map((market) => (
                    <div
                        className="itemRecord"
                        key={`${market.countryIndexId}-${market.languageIndexId}`}
                    >
                        <div className="itemRecordSection" style={{ paddingLeft: '72px' }}>
                            <div className="item">
                                {countryMap.get(market.countryIndexId)?.name}
                            </div>
                            <div className="item">
                                {languageMap.get(market.languageIndexId)?.name}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {me?.admin() && (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button style={{ width: '97px' }} onClick={() => onSave()}>
                        Save
                    </Button>
                </div>
            )}
        </div>
    );
};
